module.exports = ""


//////////////////
// WEBPACK FOOTER
// D:/Repositorios/FacturacionWeb/src/app/main/quick-panel/quick-panel.component.html
// module id = ../../../../../src/app/main/quick-panel/quick-panel.component.html
// module chunks = main